import { enCoreMessages, type CoreMessages } from '../en/core';

export const frCoreMessages = {
  ...enCoreMessages,
  common: {
    ...enCoreMessages.common,
    back: 'Retour',
    or: 'ou',
    emailAddress: 'Adresse e-mail',
  },
  navigation: {
    ...enCoreMessages.navigation,
    home: 'Accueil',
    login: 'Connexion',
    register: 'Créer compte',
    dashboard: 'Accueil',
  },
  googleAuth: {
    ...enCoreMessages.googleAuth,
    blockedAriaLabel: 'Complète d’abord les champs obligatoires',
    disabled: 'Connexion Google indisponible pour le moment.',
    failed: 'La connexion Google a échoué',
    finishing: 'Finalisation de la connexion Google...',
    tokenMissing: 'Le jeton de connexion Google n’a pas été renvoyé.',
    unavailable: 'Connexion Google indisponible',
    // App native seulement (Lot 3 stores) : boutons système Apple et Google.
    appleCta: 'Continuer avec Apple',
    googleCta: 'Continuer avec Google',
    appleFailed: 'La connexion avec Apple n’a pas abouti, essaie à nouveau dans un instant.',
    googleNativeFailed: 'La connexion avec Google n’a pas abouti, essaie à nouveau dans un instant.',
    finishingNative: 'Finalisation de la connexion…',
  },
  account: {
    ...enCoreMessages.account,
    premium: {
      title: 'Premium',
      activeLabel: 'Premium actif',
      manage: 'Gérer mon abonnement',
      packActiveLabel: "Pack déménagement actif jusqu'au {date}",
      freeDescription: 'Scans et boutique illimités, ou Pack déménagement de 6 mois.',
      upgrade: 'Passer Premium',
      manageStore: 'Gérer ou résilier',
      restore: 'Restaurer mes achats',
    },
    title: 'Paramètres',
    profile: 'Profil',
    authenticatedDescription: 'Ton compte garde ton inventaire et tes réglages synchronisés.',
    avatar: {
      add: 'Ajouter une photo',
      change: 'Changer la photo',
      remove: 'Retirer',
      uploading: 'Envoi en cours...',
      error: 'Ta photo n’a pas pu être enregistrée, essaie à nouveau.',
    },
    changePassword: 'Modifier le mot de passe',
    logout: 'Se déconnecter',
    guestTitle: 'Session invité',
    guestDescription:
      'Tu peux utiliser Liberio en invité, mais créer un compte permet d’enregistrer tes préférences et ton inventaire.',
    register: 'Créer compte',
    login: 'Se connecter',
    zone: {
      title: 'Ma zone',
      description: 'Pour te recommander les meilleures options près de chez toi.',
      placeholder: 'Nouveau code postal',
      checking: 'Vérification...',
      unknown: 'Code postal introuvable. Vérifie les 5 chiffres.',
      update: 'Mettre à jour',
      saving: 'Enregistrement...',
    },
    boutiqueMode: {
      title: 'Ta version de Liberio',
      activeLabel: 'Version boutique',
      activeDescription:
        'Scanne tes objets et partage ta boutique, où que tu sois. Les destinations et plans d’action n’existent qu’en France.',
      inactiveLabel: 'App complète (France)',
      inactiveDescription: 'Destinations, plans d’action et boutique : la version pensée pour la France.',
      switchToFull: 'Je suis en France : activer l’app complète',
      switchToBoutique: 'Repasser en version boutique',
      error: 'Le changement n’a pas été enregistré, tu peux réessayer.',
    },
    languageTitle: 'Langue',
    legal: {
      title: 'Légal',
      terms: 'Conditions générales d’utilisation et de vente (CGU/CGV)',
      privacy: 'Politique de confidentialité',
      notices: 'Mentions légales',
    },
    feedbackTitle: 'Donne ton avis',
    feedbackSubmitted:
      'Tu as déjà partagé ton avis pour la version actuelle. Tu peux le rouvrir à tout moment pour l’enrichir ou le modifier.',
    feedbackSkipped:
      'Tu as ignoré la demande d’avis, mais tu peux toujours partager ton avis depuis cette page.',
    feedbackDefault: 'Partage ton avis à tout moment.',
    feedbackCtaExisting: 'Modifier mon avis',
    feedbackCtaNew: 'Donner mon avis',
    settings: {
      groups: {
        preferences: 'Mes préférences',
        account: 'Mon compte',
        help: 'Aide et avis',
      },
      freePlan: 'Compte gratuit',
      promoSubtitle: 'Scans et boutique illimités',
      promoCta: 'Découvrir',
      reminders: {
        bannerTitle: 'Active les rappels',
        bannerSubtitle: 'Pour ne rien oublier',
        bannerCta: 'Activer',
        dismiss: 'Fermer',
        row: 'Rappels',
        on: 'Activés',
        off: 'Désactivés',
        blocked: 'Bloqués',
      },
      name: {
        edit: 'Modifier mon prénom',
        placeholder: 'Ton prénom',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        error: 'Ton prénom n’a pas pu être enregistré, essaie à nouveau.',
      },
      photo: 'Changer ma photo',
      whatsApp: 'Aide sur WhatsApp',
      legalShort: {
        terms: 'CGU/CGV',
        privacy: 'Confidentialité',
      },
    },
    whatsAppHelp: {
      title: 'Besoin d’aide ?',
      description: 'Écris-nous sur WhatsApp et dis-nous ce que tu essaies de faire avec tes objets.',
      cta: 'Aide WhatsApp',
      prefill: 'Bonjour, j’utilise Liberio et j’aimerais de l’aide.',
    },
    install: {
      title: 'Installer Liberio',
      description: 'Ouvre Liberio depuis ton écran d’accueil comme une app.',
      cta: 'Voir comment',
      directCta: 'Installer',
    },
    deleteAccount: {
      title: 'Supprimer mon compte',
      description:
        'Tu peux supprimer ton compte à tout moment. Cette action est définitive : ton inventaire, tes scans, tes photos et tes données personnelles seront effacés.',
      cta: 'Supprimer mon compte',
      confirmTitle: 'Supprimer ton compte ?',
      confirmDescription: 'Cette action est définitive. Seront effacés :',
      itemInventory: 'ton inventaire et tes scans',
      itemPhotos: 'tes photos',
      itemProgress: 'ta progression et ton carnet',
      itemPersonal: 'ton adresse e-mail et tes préférences',
      premiumNote: 'Ton abonnement Premium sera annulé immédiatement.',
      storeSubscriptionNoteIos:
        "Ton abonnement Premium acheté sur l'App Store ne s'arrête pas avec ton compte. Résilie-le dans les réglages de ton iPhone pour ne plus être facturé.",
      storeSubscriptionNoteAndroid:
        "Ton abonnement Premium acheté sur Google Play ne s'arrête pas avec ton compte. Résilie-le dans Google Play pour ne plus être facturé.",
      typeToConfirm: 'Pour confirmer, écris SUPPRIMER :',
      confirmKeyword: 'SUPPRIMER',
      confirmCta: 'Supprimer définitivement',
      deleting: 'Suppression...',
      cancel: 'Annuler',
      error: 'La suppression a échoué. Ton compte n’a pas été supprimé, réessaie dans un instant.',
    },
    notifications: {
      title: 'Alertes',
      description: 'Active les rappels pour tes prochaines actions, tes plans enregistrés et les infos utiles de Liberio.',
      cta: 'Activer les notifications',
      deniedTitle: 'Notifications bloquées',
      deniedDescriptionIos:
        'Sur iPhone : Réglages > Apps > Liberio > Notifications, puis active Autoriser les notifications.',
      deniedDescriptionGeneric:
        'Les notifications sont bloquées pour Liberio. Réactive-les dans les réglages de notifications de ton appareil ou de ton navigateur.',
    },
    languageLabels: {
      en: 'English',
      fr: 'Français',
      es: 'Español',
    },
  },
  notificationsSoftAsk: {
    title: 'Liberio fonctionne mieux avec les notifications',
    description: 'Active-les pour bénéficier de toutes les fonctionnalités : rappels, défis, suivi…',
    activate: 'Activer les notifications',
    later: 'Pas maintenant',
  },
  locationSoftAsk: {
    intro: 'Active ta position pour voir les points de dépôt et de revente autour de toi.',
    activate: 'Activer ma position',
    usePostalCode: 'Entrer mon code postal',
    postalIntro:
      "Afin de bénéficier des fonctionnalités complètes de Liberio, il nous faudrait au moins ton code postal pour qu'on t'oriente vers les entreprises locales.",
    postalLabel: 'Code postal',
    postalPlaceholder: '75011',
    postalUnknown: 'Code postal inconnu',
    checking: 'Recherche…',
    submit: 'Continuer',
    onlineOnly: 'Je ne suis intéressé que par les options en ligne',
  },
  formErrorBanner: {
    title: 'Impossible de continuer',
  },
  actionGuidance: {
    effort: {
      minimal: 'Effort : minimal',
      low: 'Effort : faible',
      medium: 'Effort : moyen',
      high: 'Effort : élevé',
    },
    money: {
      none: 'Gain : aucun',
      low: 'Gain : faible',
      medium: 'Gain : moyen',
      high: 'Gain : élevé',
      highest: 'Gain : maximum',
    },
    meter: {
      effort: 'Effort',
      money: 'Gain',
    },
  },
  listingSummary: {
    selectedItem: 'Objet sélectionné',
    selectedItemAlt: 'Objet sélectionné',
    item: 'Objet',
    untitledItem: 'Objet sans titre',
  },
  taxonomy: {
    conditions: {
      like_new: 'Comme neuf',
      good: 'Bon état',
      fair: 'Utilisé',
      poor: 'Mauvais',
    },
    labels: {
      electronics: 'Électronique',
      smartphone: 'Smartphone',
      'feature-phone': 'Téléphone classique',
      tablet: 'Tablette',
      smartwatch: 'Montre connectée',
      'headphones-audio': 'Casques et audio',
      camera: 'Appareil photo',
      television: 'Téléviseur',
      'gaming-console': 'Console de jeu',
      computers: 'Informatique',
      laptop: 'Ordinateur portable',
      'desktop-computer': 'Ordinateur de bureau',
      monitor: 'Moniteur',
      'pc-component': 'Composant PC',
      'networking-gear': 'Équipement réseau',
      'printer-scanner': 'Imprimante et scanner',
      'computer-accessory': 'Accessoire informatique',
      'home-appliances': 'Électroménager',
      'small-kitchen-appliance': 'Petit appareil de cuisine',
      'large-kitchen-appliance': 'Gros électroménager',
      'cleaning-appliance': 'Appareil de nettoyage',
      'climate-control-appliance': 'Appareil de climatisation',
      'personal-care-appliance': 'Appareil de soin personnel',
      furniture: 'Meubles',
      sofa: 'Canapé',
      table: 'Table',
      chair: 'Chaise',
      'storage-furniture': 'Meuble de rangement',
      'bedroom-furniture': 'Meuble de chambre',
      'office-furniture': 'Mobilier de bureau',
      'outdoor-furniture': 'Mobilier d’extérieur',
      'home-decor': 'Maison et décoration',
      lighting: 'Éclairage',
      'rug-textile': 'Tapis et textile',
      'wall-art': 'Art mural',
      kitchenware: 'Ustensiles de cuisine',
      'garden-decor': 'Décoration de jardin',
      fashion: 'Mode',
      'womens-clothing': 'Vêtements femme',
      'mens-clothing': 'Vêtements homme',
      footwear: 'Chaussures',
      bag: 'Sac',
      'watch-jewelry': 'Montres et bijoux',
      'fashion-accessory': 'Accessoire de mode',
      'baby-kids': 'Bébé et enfants',
      stroller: 'Poussette',
      'car-seat': 'Siège auto',
      'baby-gear': 'Équipement bébé',
      'kids-clothing': 'Vêtements enfant',
      'learning-toy': 'Jouet éducatif',
      'maternity-item': 'Article de maternité',
      'sports-outdoors': 'Sports et plein air',
      'fitness-gear': 'Équipement de fitness',
      bicycle: 'Vélo',
      'standard-bike': 'Vélo standard',
      'e-bike': 'Vélo électrique',
      'running-gear': 'Équipement de course',
      'team-sport-gear': 'Équipement de sport collectif',
      'camping-hiking-gear': 'Équipement de camping et randonnée',
      'water-sport-gear': 'Équipement de sport nautique',
      'tools-diy': 'Outils et bricolage',
      'power-tool': 'Outil électrique',
      'hand-tool': 'Outil manuel',
      'workshop-equipment': 'Équipement d’atelier',
      'construction-material': 'Matériau de construction',
      'gardening-tool': 'Outil de jardinage',
      'auto-moto': 'Auto et moto',
      'car-part': 'Pièce auto',
      'moto-part': 'Pièce moto',
      'wheel-tire': 'Roue et pneu',
      'car-electronic': 'Équipement électronique auto',
      'vehicle-accessory': 'Accessoire véhicule',
      'books-media': 'Livres et médias',
      book: 'Livre',
      'comic-magazine': 'Bande dessinée et magazine',
      'movie-disc': 'DVD et Blu-ray',
      dvd: 'DVD',
      'blu-ray': 'Blu-ray',
      'music-recording': 'CD et vinyles',
      cd: 'CD',
      vinyl: 'Vinyle',
      'games-toys': 'Jeux et jouets',
      'video-game': 'Jeu vidéo',
      'board-game': 'Jeu de société',
      puzzle: 'Puzzle',
      'action-figure': 'Figurine',
      'educational-toy': 'Jouet éducatif',
      'collectibles-art': 'Collections et art',
      antique: 'Antiquité',
      'coin-stamp': 'Pièce et timbre',
      'trading-card': 'Carte à collectionner',
      artwork: 'Œuvre d’art',
      'vintage-item': 'Objet vintage',
      'musical-instruments': 'Instruments de musique',
      'guitar-bass': 'Guitare et basse',
      'keyboard-piano': 'Clavier et piano',
      'drum-percussion': 'Batterie et percussion',
      'dj-audio-gear': 'Matériel DJ et audio',
      'studio-recording-gear': 'Matériel de studio',
      'wind-string-instrument': 'Instrument à vent et à cordes',
      'health-beauty': 'Santé et beauté',
      'skincare-item': 'Produit de soin',
      'makeup-item': 'Produit de maquillage',
      'haircare-item': 'Produit capillaire',
      'wellness-device': 'Appareil de bien-être',
      'medical-equipment': 'Équipement médical',
      pets: 'Animaux',
      'pet-supplies': 'Accessoires pour animaux',
      plants: 'Plantes',
      'live-plant': 'Plante vivante',
      iphone: 'iPhone',
      'android-phone': 'Téléphone Android',
      'standard-tablet': 'Tablette standard',
      'drawing-tablet': 'Tablette graphique',
      'e-reader': 'Liseuse',
      'fitness-band': 'Bracelet de fitness',
      headphones: 'Casque',
      earbuds: 'Écouteurs',
      speaker: 'Enceinte',
      'hifi-component': 'Élément hi-fi',
      'camera-body': 'Boîtier photo',
      'camera-lens': 'Objectif photo',
      'action-camera': 'Caméra d’action',
      camcorder: 'Caméscope',
      'camera-accessory': 'Accessoire photo',
      projector: 'Vidéoprojecteur',
      'home-cinema': 'Home cinéma',
      playstation: 'Console PlayStation',
      xbox: 'Console Xbox',
      nintendo: 'Console Nintendo',
      'handheld-console': 'Console portable',
      'gaming-accessory': 'Accessoire de jeu vidéo',
      'mobile-accessory': 'Accessoire mobile',
      'phone-case': 'Coque de téléphone',
      'charger-cable': 'Chargeur et câble',
      'screen-protector': 'Protection d’écran',
      'wearable-accessory': 'Accessoire connecté',
      'smart-home-device': 'Objet connecté pour la maison',
      'smart-speaker': 'Enceinte connectée',
      'security-camera': 'Caméra de surveillance',
      'smart-lighting': 'Éclairage connecté',
      'smart-thermostat': 'Thermostat connecté',
      macbook: 'MacBook',
      'windows-laptop': 'Ordinateur portable Windows',
      chromebook: 'Chromebook',
      'desktop-tower': 'Tour (unité centrale)',
      'all-in-one': 'Tout-en-un',
      'mini-pc': 'Mini PC',
      'computer-monitor': 'Écran d’ordinateur',
      'portable-monitor': 'Écran portable',
      'graphics-card': 'Carte graphique',
      processor: 'Processeur',
      memory: 'Mémoire',
      'storage-drive': 'Disque de stockage',
      motherboard: 'Carte mère',
      'power-supply': 'Alimentation',
      'pc-case': 'Boîtier PC',
      router: 'Routeur',
      modem: 'Modem',
      'wifi-extender': 'Répéteur Wi-Fi',
      'network-switch': 'Commutateur réseau',
      'inkjet-printer': 'Imprimante jet d’encre',
      'laser-printer': 'Imprimante laser',
      scanner: 'Scanner',
      '3d-printer': 'Imprimante 3D',
      keyboard: 'Clavier',
      'mouse-trackpad': 'Souris et pavé tactile',
      'docking-station': 'Station d’accueil',
      'cable-adapter': 'Câble et adaptateur',
      'computer-bag': 'Sacoche pour ordinateur',
      'coffee-machine': 'Machine à café',
      microwave: 'Micro-ondes',
      toaster: 'Grille-pain',
      blender: 'Mixeur',
      kettle: 'Bouilloire',
      'food-processor': 'Robot culinaire',
      'air-fryer': 'Friteuse à air',
      'refrigerator-freezer': 'Réfrigérateur et congélateur',
      dishwasher: 'Lave-vaisselle',
      'oven-cooktop': 'Four et plaque de cuisson',
      'extractor-hood': 'Hotte aspirante',
      'laundry-appliance': 'Appareil de lavage',
      'washing-machine': 'Machine à laver',
      'tumble-dryer': 'Sèche-linge',
      'washer-dryer': 'Lave-linge séchant',
      vacuum: 'Aspirateur',
      'robot-vacuum': 'Robot aspirateur',
      'steam-cleaner': 'Nettoyeur vapeur',
      heater: 'Chauffage',
      fan: 'Ventilateur',
      'air-conditioner': 'Climatiseur',
      'air-purifier': 'Purificateur d’air',
      dehumidifier: 'Déshumidificateur',
      'hair-dryer': 'Sèche-cheveux',
      'hair-styler': 'Appareil coiffant',
      shaver: 'Rasoir',
      'electric-toothbrush': 'Brosse à dents électrique',
      armchair: 'Fauteuil',
      'dining-table': 'Table à manger',
      'coffee-table': 'Table basse',
      desk: 'Bureau',
      'dining-chair': 'Chaise de salle à manger',
      'office-chair': 'Chaise de bureau',
      stool: 'Tabouret',
      wardrobe: 'Armoire',
      dresser: 'Commode',
      'bookcase-shelf': 'Bibliothèque et étagère',
      cabinet: 'Buffet',
      'bed-frame': 'Cadre de lit',
      'bedside-table': 'Table de chevet',
      mattress: 'Matelas',
      'adult-mattress': 'Matelas adulte',
      'child-mattress': 'Matelas enfant',
      'mattress-topper': 'Surmatelas',
      'office-desk': 'Bureau',
      'garden-table-chair': 'Table et chaise de jardin',
      'outdoor-storage': 'Rangement d’extérieur',
      lamp: 'Lampe',
      'ceiling-light': 'Plafonnier',
      bulb: 'Ampoule',
      'light-fixture': 'Luminaire',
      'household-linen': 'Linge de maison',
      'rug-carpet': 'Tapis et moquette',
      curtains: 'Rideaux',
      'cushion-pillow': 'Coussin et oreiller',
      'blanket-duvet': 'Couverture et couette',
      'print-poster': 'Estampe et poster',
      painting: 'Peinture',
      'mirror-frame': 'Miroir et cadre',
      tableware: 'Vaisselle',
      cookware: 'Casseroles',
      'kitchen-tool': 'Ustensile de cuisine',
      cutlery: 'Couverts',
      'plant-pot': 'Pot de fleurs',
      planter: 'Jardinière',
      'garden-decoration': 'Décoration de jardin',
      't-shirt-top': 'T-shirt et haut',
      'shirt-blouse': 'Chemise et blouse',
      'jeans-trousers': 'Jean et pantalon',
      'dress-skirt': 'Robe et jupe',
      outerwear: 'Manteau',
      knitwear: 'Maille',
      sportswear: 'Sport',
      'suit-formal': 'Costume et tenue habillée',
      shirt: 'Chemise',
      sneakers: 'Baskets',
      boots: 'Bottes',
      'formal-shoes': 'Chaussures habillées',
      sandals: 'Sandales',
      handbag: 'Sac à main',
      backpack: 'Sac à dos',
      luggage: 'Bagage',
      'wallet-small-leather': 'Portefeuille et petite maroquinerie',
      watch: 'Montre',
      jewelry: 'Bijou',
      'costume-jewelry': 'Bijou fantaisie',
      sunglasses: 'Lunettes de soleil',
      belt: 'Ceinture',
      scarf: 'Écharpe',
      hat: 'Chapeau',
      tie: 'Cravate',
      'standard-stroller': 'Poussette standard',
      'travel-stroller': 'Poussette de voyage',
      'double-stroller': 'Poussette double',
      'infant-car-seat': 'Coque auto bébé',
      'child-car-seat': 'Siège auto enfant',
      'booster-seat': 'Rehausseur auto',
      carrier: 'Porte-bébé',
      'crib-cot': 'Berceau et lit bébé',
      'high-chair': 'Chaise haute',
      'baby-monitor': 'Babyphone',
      'feeding-gear': 'Équipement de repas',
      'baby-bath-changing': 'Bain et change bébé',
      'baby-clothing': 'Vêtements bébé',
      'child-clothing': 'Vêtements enfant',
      'kids-footwear': 'Chaussures enfant',
      'baby-toy': 'Jouet bébé',
      'maternity-clothing': 'Vêtements de grossesse',
      'nursing-gear': 'Équipement d’allaitement',
      'child-furniture': 'Mobilier enfant',
      'kids-bed': 'Lit enfant',
      'kids-mattress': 'Matelas enfant',
      'nursery-storage': 'Rangement chambre d’enfant',
      'kids-desk-chair': 'Bureau et chaise enfant',
      weights: 'Poids',
      'cardio-machine': 'Machine de cardio',
      'yoga-pilates': 'Yoga et Pilates',
      'boxing-mma': 'Boxe et MMA',
      'bicycle-accessory': 'Accessoire vélo',
      helmet: 'Casque',
      'child-seat-trailer': 'Siège enfant et remorque',
      'bike-part': 'Pièce de vélo',
      'bike-rack-bag': 'Porte-bagage et sac de vélo',
      'e-scooter-mobility': 'Trottinette et mobilité',
      'e-scooter': 'Trottinette électrique',
      'kick-scooter': 'Trottinette',
      'mobility-scooter': 'Scooter de mobilité',
      'running-shoes': 'Chaussures de course',
      'gps-watch': 'Montre GPS',
      'running-accessory': 'Accessoire de course',
      football: 'Football',
      basketball: 'Basketball',
      rugby: 'Rugby',
      'protection-gear': 'Équipement de protection',
      tent: 'Tente',
      'sleeping-bag': 'Sac de couchage',
      'hiking-poles': 'Bâtons de randonnée',
      surfboard: 'Planche de surf',
      paddleboard: 'Paddle',
      wetsuit: 'Combinaison de plongée',
      'diving-gear': 'Équipement de plongée',
      'racket-sport-gear': 'Sport de raquette',
      tennis: 'Tennis',
      badminton: 'Badminton',
      padel: 'Padel',
      'table-tennis': 'Tennis de table',
      'winter-sport-gear': 'Sport d’hiver',
      skis: 'Skis',
      snowboard: 'Snowboard',
      'winter-boots': 'Bottes d’hiver',
      'fishing-gear': 'Pêche',
      'fishing-rod': 'Canne à pêche',
      reel: 'Moulinet',
      'tackle-box': 'Boîte de pêche',
      'equestrian-gear': 'Équitation',
      saddle: 'Selle',
      'riding-clothing': 'Vêtement d’équitation',
      'horse-tack': 'Harnachement de cheval',
      'drill-driver': 'Perceuse et visseuse',
      saw: 'Scie',
      'sander-grinder': 'Ponceuse et meuleuse',
      'battery-charger': 'Pile et chargeur',
      'electric-garden-tool': 'Outil de jardin électrique',
      hammer: 'Marteau',
      'screwdriver-wrench': 'Tournevis et clé',
      'hand-saw': 'Scie à main',
      'measuring-tool': 'Outil de mesure',
      ladder: 'Échelle',
      workbench: 'Établi',
      compressor: 'Compresseur',
      'welding-tool': 'Outil de soudure',
      'wood-timber': 'Bois et madriers',
      'metal-material': 'Matériau métallique',
      'tiles-ceramic': 'Carrelage et céramique',
      'plumbing-fixture': 'Équipement de plomberie',
      'door-window': 'Porte et fenêtre',
      insulation: 'Isolant',
      'lawn-mower': 'Tondeuse',
      'hedge-trimmer': 'Taille-haie',
      'garden-hand-tool': 'Outil de jardin à main',
      'watering-equipment': 'Équipement d’arrosage',
      'body-part': 'Élément de carrosserie',
      'mechanical-part': 'Pièce mécanique',
      'moto-body-part': 'Pièce de carrosserie moto',
      'moto-mechanical-part': 'Pièce mécanique moto',
      tire: 'Pneu',
      'wheel-rim': 'Roue et jante',
      'car-audio': 'Autoradio',
      'gps-dashcam': 'GPS et caméra embarquée',
      'roof-rack': 'Barres de toit',
      'car-seat-cover': 'Housse de siège auto',
      'motorcycle-gear': 'Équipement moto',
      'novel-literature': 'Roman et littérature',
      textbook: 'Manuel scolaire',
      'children-book': 'Livre pour enfant',
      'comic-book': 'BD',
      manga: 'Manga',
      'art-book': 'Livre d’art',
      comic: 'BD',
      magazine: 'Magazine',
      'switch-game': 'Jeu Switch',
      'playstation-game': 'Jeu PlayStation',
      'xbox-game': 'Jeu Xbox',
      'pc-game': 'Jeu PC',
      'construction-set': 'Jeu de construction',
      lego: 'Briques LEGO',
      duplo: 'Briques Duplo',
      'compatible-bricks': 'Briques compatibles',
      'doll-plush': 'Poupée et peluche',
      'model-figure': 'Figurine',
      'science-kit': 'Kit scientifique',
      'craft-kit': 'Kit de loisir créatif',
      'electronic-toy': 'Jouet électronique',
      'remote-control-toy': 'Jouet télécommandé',
      'battery-toy': 'Jouet à piles',
      'electronic-learning-toy': 'Jouet éducatif électronique',
      'outdoor-toy': 'Jouet d’extérieur',
      'ride-on-toy': 'Porteur',
      'playground-toy': 'Jeu d’extérieur',
      'antique-furniture': 'Meuble ancien',
      'antique-decor': 'Décoration ancienne',
      coin: 'Pièce de monnaie',
      banknote: 'Billet de banque',
      stamp: 'Timbre',
      postcard: 'Carte postale',
      'tcg-card': 'Carte TCG',
      'sports-card': 'Carte de sport',
      sculpture: 'Sculpture',
      print: 'Estampe',
      memorabilia: 'Objet de collection',
      'advertising-collectible': 'Objet publicitaire de collection',
      militaria: 'Militaria',
      'model-kit': 'Maquette',
      'tabletop-miniature': 'Figurine de jeu',
      'acoustic-guitar': 'Guitare acoustique',
      'electric-guitar': 'Guitare électrique',
      'bass-guitar': 'Guitare basse',
      'digital-piano': 'Piano numérique',
      'acoustic-piano': 'Piano acoustique',
      'drum-kit': 'Batterie',
      cymbal: 'Cymbale',
      percussion: 'Percussion',
      turntable: 'Platine vinyle',
      mixer: 'Table de mixage',
      controller: 'Contrôleur',
      microphone: 'Microphone',
      'audio-interface': 'Interface audio',
      'studio-monitor': 'Enceinte',
      violin: 'Violon',
      'wind-instrument': 'Instrument à vent',
      'brass-instrument': 'Cuivres',
      'sealed-skincare': 'Soin scellé',
      'sealed-makeup': 'Maquillage scellé',
      'sealed-haircare': 'Soin capillaire scellé',
      'massage-device': 'Appareil de massage',
      'fitness-health-tracker': 'Bracelet santé et fitness',
      'mobility-aid': 'Aide à la mobilité',
      'medical-device': 'Appareil médical',
      'medical-consumable': 'Consommable médical',
      'pet-bed': 'Couchage pour animal',
      'pet-carrier': 'Caisse de transport pour animal',
      'pet-toy': 'Jouet pour animal',
      'leash-collar': 'Laisse et collier',
      'pet-bowl': 'Gamelle pour animal',
      'aquarium-terrarium-equipment': 'Équipement aquarium et terrarium',
      'plant-cutting': 'Bouture',
      'potted-plant': 'Plante en pot',
      'plant-care-supplies': 'Accessoires pour plantes',
      'plant-care-tool': 'Outil de jardinage',
      'office-school': 'Bureau et école',
      stationery: 'Papeterie',
      'notebooks-paper': 'Cahiers et papier',
      'writing-supplies': 'Matériel d’écriture',
      'school-supplies': 'Fournitures scolaires',
      calculator: 'Calculatrice',
      'art-supplies': 'Fournitures d’art',
      'office-equipment': 'Équipement de bureau',
      shredder: 'Destructeur de documents',
      laminator: 'Plastifieuse',
      'label-maker': 'Étiqueteuse',
      'office-phone': 'Téléphone de bureau',
      'office-supplies': 'Fournitures de bureau',
      'filing-storage': 'Classement et rangement',
      'desk-accessory': 'Accessoire de bureau',
      'printer-consumable': 'Consommable d’imprimante',
      'restricted-good': 'Objet restreint',
      'food-beverage': 'Alimentation et boissons',
      'live-animal': 'Animal vivant',
      'hazardous-material': 'Matière dangereuse',
      'service-listing': 'Service',
      vehicle: 'Véhicule',
      'real-estate': 'Immobilier',
      other: 'Autre',
      'general-item': 'Objet générique',
    },
  },
  // Écran bloquant de mise à jour forcée (app native, Lot 5).
  nativeUpdate: {
    title: 'Mise à jour nécessaire',
    body: 'Cette version de Liberio est trop ancienne pour continuer. Mets-la à jour pour retrouver tes objets.',
    cta: 'Mettre à jour',
    storeHint: 'Ouvre l’App Store pour installer la dernière version.',
    storeHintAndroid: 'Ouvre le Play Store pour installer la dernière version.',
    // Rappel doux (chantier « versions natives », textes validés par David le
    // 22/09/2026) : une coquille plus récente est publiée sur le store.
    reminderTitle: 'Une nouvelle version de Liberio est là',
    reminderBody: 'Elle t’attend sur l’App Store, avec les dernières améliorations. Ça prend une minute.',
    reminderBodyAndroid: 'Elle t’attend sur le Play Store, avec les dernières améliorations. Ça prend une minute.',
    reminderCta: 'Mettre à jour',
    reminderLater: 'Plus tard',
  },
  // Bouton retour matériel d'Android, depuis l'accueil (chantier Google Play).
  nativeBack: {
    exitConfirm: 'Appuie encore pour quitter Liberio',
  },
  tabs: {
    ...enCoreMessages.tabs,
    openScanner: 'Ouvrir le scanner',
    scan: 'Scanner',
    // « Mes objets » et non « Objets » : les deux onglets se répondent, et
    // l'écran porte ce titre dans son bandeau.
    items: 'Mes objets',
    settings: 'Paramètres',
    shop: 'Ma boutique',
  },
  map: {
    ...enCoreMessages.map,
    you: 'Toi',
    searchInZone: 'Rechercher dans cette zone',
    backToMyPlace: 'Retour à ma position',
  },
  motivation: {
    title: 'Merci, c’est noté',
    body: 'Ça nous aide à améliorer nos services pour t’être encore plus utile !',
    scan: 'Scanner un objet',
  },
  // Page de repli du bouton « Ouvrir Liberio » (liberio.app/app) : l'app
  // n'est pas installée, on part vers le store.
  ouvrir: {
    redirecting: 'On t’emmène vers le store…',
  },
} satisfies CoreMessages;
